var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-page" },
    [
      _c(
        "b-container",
        [
          _c("h5", { staticClass: "auth-logo" }, [
            _c("i", { staticClass: "fa fa-circle text-gray" }),
            _vm._v("\n            Starchase\n            "),
            _c("i", { staticClass: "fa fa-circle text-warning" })
          ]),
          _vm._v(" "),
          _c(
            "Widget",
            {
              staticClass: "widget-auth mx-auto",
              attrs: {
                title: "<h3 class='mt-0'>Login to Starchase</h3>",
                customHeader: ""
              }
            },
            [
              _c("p", { staticClass: "widget-auth-info" }, [
                _vm._v(
                  "\n                Use your email to sign in.\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "mt",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login($event)
                    }
                  }
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "alert-sm",
                      attrs: { variant: "danger", show: !!_vm.errorMessage }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.errorMessage) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      ref: "username",
                      staticClass: "form-control no-border",
                      attrs: {
                        required: "",
                        type: "email",
                        name: "email",
                        placeholder: "Email"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      ref: "password",
                      staticClass: "form-control no-border",
                      attrs: {
                        required: "",
                        type: "password",
                        name: "password",
                        placeholder: "Password"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "auth-btn mb-3",
                      attrs: { type: "submit", size: "sm", variant: "inverse" }
                    },
                    [_vm._v(_vm._s(this.isFetching ? "Loading..." : "Login"))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }